import AxiosControl from '../components/axios/AxiosControl'
const Axios = AxiosControl()

export const getUsers = (page = null, limit = null, search = '') => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/user/getall/', { page, limit, search }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'USER_GETALL_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const getUser = (user) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/user/get/' + user, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'USER_GET_SUCCESS',
                payload: data.user
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const addUser = (userdata) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/user/register', userdata, {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'USER_ADD_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const activeUser = (user, codVerification) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/login/activate/' + user, { activate_code: codVerification }, {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200 || status === 264) {
            dispatch({
                type: 'USER_EDIT_SUCCESS',
                payload: data.message
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const sendVerificationCode = (user) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.post('/api/user/sendverificationcode/' + user, {}, {
            headers: { auth: localStorage.getItem('jwt') }
        }
        )
        if (status === 200) {
            dispatch({
                type: 'USER_EMAILSEND',
                payload: data.message
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const editUser = (userdata, idUser) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/user/edit/' + idUser, userdata, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'USER_EDIT_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_ERROR'
        })
    }
}

export const enableUser = (idUser) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/user/enable/' + idUser, {}, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        }
        )
        if (status === 200 || status === 264 || status === 260) {
            dispatch({
                type: 'USER_ENABLEDISABLE_SUCCESS',
                payload: { ...data, idUser: idUser }
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_ERROR'
        })
    }
}

export const disableUser = (idUser) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.put('/api/user/disable/' + idUser, {}, {
            headers: {
                auth: localStorage.getItem('jwt')
            }
        }
        )
        if (status === 200 || status === 263 || status === 260) {
            dispatch({
                type: 'USER_ENABLEDISABLE_SUCCESS',
                payload: { ...data, idUser: idUser }
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_ERROR'
        })
    }
}

export const removeUser = (userId) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { status } = await Axios.delete('/api/user/remove/' + userId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'USER_REMOVE_SUCCESS'
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const importTeachers = () => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { status } = await Axios.get('/api/user/importteachers', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TEACHER_IMPORT_SUCCESS'
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const importStudents = () => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { status } = await Axios.get('/api/user/importstudents', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'STUDENT_IMPORT_SUCCESS'
            })
        }
    } catch (error) {
        dispatch({
            type: 'USER_NOT_LOADING'
        })
    }
}

export const getStudentOdoo = (id) => async (dispatch) => {
    dispatch({
        type: 'USER_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/user/getstudentodoo/' + id, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'STUDENT_GET_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'STUDENT_GET_ERROR',
            payload: error.response?.data?.error || error.message
        })
    }
}

export const getDashboardMe = () => async (dispatch) => {
    try {
        const { data, status } = await Axios.get('/api/dashboard/me', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'DASHBOARD_ME_SUCCESS',
                payload: data
            })
        }
    } catch (error) {
        dispatch({
            type: 'DASHBOARD_ME_ERROR',
            payload: error.response?.data?.message || error.message
        })
    }
}

export const selectStudent = (studentId) => (dispatch) => {
    dispatch({
        type: 'SELECT_STUDENT',
        payload: studentId
    })
}

export const getStudentInvoices = (odooId) => async (dispatch) => {
    dispatch({ type: 'INVOICES_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/dashboard/invoices', {
            params: { odooId },
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'INVOICES_SUCCESS',
                payload: { invoices: data.invoices, documents: data.documents }
            })
        }
    } catch (error) {
        dispatch({
            type: 'INVOICES_ERROR',
            payload: error.response?.data?.error || error.message
        })
    }
}

export const getFollowUp = () => async (dispatch) => {
    dispatch({ type: 'FOLLOWUP_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/dashboard/follow-up', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'FOLLOWUP_SUCCESS',
                payload: data.followUp || []
            })
        }
    } catch (error) {
        dispatch({
            type: 'FOLLOWUP_ERROR',
            payload: error.response?.data?.message || error.message
        })
    }
}

export const updateProfile = (data) => async (dispatch) => {
    dispatch({ type: 'PROFILE_UPDATING' })
    try {
        const { data: result, status } = await Axios.put('/api/profile/me', data, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'PROFILE_UPDATE_SUCCESS',
                payload: result.message
            })
        }
    } catch (error) {
        dispatch({
            type: 'PROFILE_UPDATE_ERROR',
            payload: error.response?.data?.message || error.message
        })
    }
}

export const getNotifications = () => async (dispatch) => {
    dispatch({ type: 'NOTIFICATIONS_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/dashboard/notifications', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'NOTIFICATIONS_SUCCESS',
                payload: { notifications: data.notifications, unreadCount: data.unreadCount }
            })
        }
    } catch (error) {
        dispatch({
            type: 'NOTIFICATIONS_ERROR',
            payload: error.response?.data?.message || error.message
        })
    }
}

export const getNoticeboard = () => async (dispatch) => {
    dispatch({ type: 'NOTICEBOARD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/dashboard/notifications', {
            params: { type: 'noticeboard' },
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'NOTICEBOARD_SUCCESS',
                payload: data.notifications
            })
        }
    } catch (error) {
        dispatch({
            type: 'NOTICEBOARD_ERROR',
            payload: error.response?.data?.message || error.message
        })
    }
}

export const getSentMessages = () => async (dispatch) => {
    dispatch({ type: 'SENT_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/dashboard/notifications', {
            params: { box: 'sent' },
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SENT_SUCCESS',
                payload: data.notifications
            })
        }
    } catch (error) {
        dispatch({
            type: 'SENT_ERROR',
            payload: error.response?.data?.message || error.message
        })
    }
}

export const getThread = (threadId) => async (dispatch) => {
    dispatch({ type: 'THREAD_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/dashboard/notifications/thread/' + threadId, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'THREAD_SUCCESS',
                payload: data.messages
            })
        }
    } catch (error) {
        dispatch({
            type: 'THREAD_ERROR',
            payload: error.response?.data?.message || error.message
        })
    }
}

export const resetThread = () => async (dispatch) => {
    dispatch({ type: 'THREAD_RESET' })
}

export const markNotificationRead = (notificationId) => async (dispatch) => {
    try {
        const { status } = await Axios.put('/api/dashboard/notifications/' + notificationId + '/read', {}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch(getNotifications())
        }
    } catch (error) {
        console.error('Error al marcar la notificación como leída', error)
    }
}

export const markAllNotificationsRead = () => async (dispatch) => {
    try {
        const { status } = await Axios.put('/api/dashboard/notifications/read-all', {}, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch(getNotifications())
        }
    } catch (error) {
        console.error('Error al marcar las notificaciones como leídas', error)
    }
}

export const getInvoicesAll = () => async (dispatch) => {
    dispatch({ type: 'INVOICES_ALL_LOADING' })
    try {
        const { data, status } = await Axios.get('/api/dashboard/invoices-all', {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'INVOICES_ALL_SUCCESS',
                payload: data.results || {}
            })
        }
    } catch (error) {
        dispatch({
            type: 'INVOICES_ALL_ERROR',
            payload: error.response?.data?.message || error.message
        })
    }
}

export const contactTutor = (data) => async (dispatch) => {
    dispatch({ type: 'TUTOR_MESSAGE_SENDING' })
    try {
        const { data: result, status } = await Axios.post('/api/dashboard/messages', data, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'TUTOR_MESSAGE_SUCCESS',
                payload: result.message
            })
            return result.message || true
        }
        return false
    } catch (error) {
        dispatch({
            type: 'TUTOR_MESSAGE_ERROR',
            payload: error.response?.data?.message || error.message
        })
        return false
    }
}

export const resetTutorMessage = () => async (dispatch) => {
    dispatch({ type: 'TUTOR_MESSAGE_RESET' })
}

export const uploadAvatar = (imageUrl) => async (dispatch) => {
    dispatch({ type: 'AVATAR_UPLOADING' })
    try {
        const { data, status } = await Axios.put('/api/profile/avatar', { avatar: imageUrl }, {
            headers: { auth: localStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'AVATAR_SUCCESS',
                payload: data.avatar
            })
        }
    } catch (error) {
        dispatch({
            type: 'AVATAR_ERROR',
            payload: error.response?.data?.message || error.message
        })
    }
}